module.exports = __webpack_public_path__ + "img/CalendarIconGrey.6ab35f74.svg";